// export const BASE_URL = "http://localhost:8000/api/";
// export const IMAGE_PATH = "http://localhost:8000";
// export const CLIENT_ID = '272528117587-koq77mk7tka7u9cnper9v9gomdlb526e.apps.googleusercontent.com'


export const BASE_URL = "https://store.xkeiwellness.com/apis/public/api/";
export const IMAGE_PATH = "https://store.xkeiwellness.com/apis/public";
export const CLIENT_ID ='24534174823-2ealm27mqv88qhh50uo87gqrfj7comqg.apps.googleusercontent.com'

